import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { IndexHeader } from "@/components/IndexHeader";
import vueScroll from "vuescroll";

@Component({
    components: {
        IndexHeader,
        vueScroll
    }
})
export default class NoteCatalog extends Vue {
    private ops: any = {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(255, 255, 255, .4)"
        }
    };
    @Prop() readonly noteCatalogList: any;
    handleSectionClick(
        sectionItem: any,
        chapterItem: any,
        moduleItem: any,
        groupItem: any
    ) {
        this.$emit(
            "section-click",
            sectionItem,
            chapterItem,
            moduleItem,
            groupItem
        );
    }
}

//@ts-ignore
export { default as NoteCatalog } from "./index.vue";
